/**
 * approvalPages — the pure approval-page derivation selector.
 *
 * The New_Review_Surface exposes a per-page director-approval action for
 * exactly the Form_Pages flagged `requiresDirectorApproval` (design Property 7,
 * Req 7.4). `approvalActionPages` is the single pure function that decides that
 * subset: given the `FormPage` list `listFormPages` returns, it yields exactly
 * the approval-required pages — no approval-required page omitted, no
 * non-approval page surfaced.
 *
 * This consumes the existing `FormPage` shape from the application-form client
 * seam rather than re-deriving it, so the review surface and this selector can
 * never disagree about a page's approval requirement. It is pure logic: no I/O,
 * no module-level mutable state, and the input array is never mutated.
 *
 * Validates: application-surface-reconciliation Requirements 7.4
 */

import type { FormPage } from '@/lib/application-form/client/types';

/**
 * The subset of `pages` whose `requiresDirectorApproval` is true — exactly the
 * pages the review surface offers a per-page approval action for. Order is
 * preserved from the input; the input is not mutated.
 */
export function approvalActionPages(pages: readonly FormPage[]): FormPage[] {
  return pages.filter((page) => page.requiresDirectorApproval);
}
